import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { CancelamentoPjService } from '@/core/api/sicom-api/servicos/pessoa-juridica/cancelamento-pj/cancelamento-pj.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { CancelamentoPjRequest, CancelamentoPjResponse } from '@/core/api/sicom-api/servicos/pessoa-juridica/cancelamento-pj/cancelamento-pj.model';

@Injectable({ providedIn: 'root' })
export class CancelamentoPjServicosService {
    constructor(
        private api: CancelamentoPjService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: CancelamentoPjRequest, context?: HttpContext): Observable<CancelamentoPjResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
